<template>
  <breadCrumbs title="To-Do" title1="To-Do" />

  <div class="container-fluid email-wrap bookmark-wrap todo-wrap">
    <div class="row">
      <todoSidebar />
      <div class="col-xl-9 xl-70 box-col-70">
        <addTask />
      </div>

    </div>
  </div>
</template>
<script>
import todoSidebar from "./todoSidebar.vue";
import addTask from "./addTask.vue"
import { mapState } from 'vuex';
export default {
  components: {
    todoSidebar, addTask
  },
  data() {
    return {
      markallread: true,
      task: '',
      addtask: false,
    }
  },
  computed: {
    ...mapState({
      todolist: state => state.todo.todo,
    })
  },
  methods: {
    alltaskcomplete() {
      this.$store.dispatch('todo/alltaskcomplete', this.markallread);
      this.markallread = !this.markallread;
      if (this.markallread)
        this.$toast.show('All tasks marked as Incomplete.', { theme: 'outline', position: 'top-right', type: 'error', duration: 2000 });
      else
        this.$toast.show('All tasks marked as complete.', { theme: 'outline', position: 'top-right', type: 'success', duration: 2000 });
    },
    tododelete(id) {
      this.$store.dispatch('todo/tododelete', id);
      this.$toast.show('Task has been deleted.', { theme: 'outline', position: 'top-right', type: 'success', duration: 2000 });
    },
    taskcomplete(id, status) {
      this.$store.dispatch('todo/taskcomplete', id);
      if (status !== 'complete')
        this.$toast.show(' tasks marked as complete.', { theme: 'outline', position: 'top-right', type: 'success', duration: 2000 });
      else
        this.$toast.show(' tasks marked as incomplete.', { theme: 'outline', position: 'top-right', type: 'error', duration: 2000 });
    },
  }
}
</script>
